import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page-wrapper ghost" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<nav class=\"navbar shadow\"><div class=\"container-fluid\"><a class=\"navbar-brand ghost__logo\" href=\"#\"></a><div class=\"btn-group user__profile d-flex align-items-center\"><span class=\"user__initial\"></span><span class=\"user__name d-md-flex d-none\"></span></div></div></nav>", 1)
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "loader-text" }, "Authenticating...", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      ($setup.auth0.isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}